<cds-notification-center
  [actions]="inboxFacade"
  [isLoading]="isLoading()"
  [isLoadingMore]="isLoadingMore()"
  [isOpen]="isOpen()"
  [now]="null"
  [page]="page()"
  [unreadCount]="unreadCount()"
  (closeRequested)="handleCloseRequested()"
  (openRequested)="handleOpenRequested()"
  (redirectIntent)="handleRedirectIntent($event)"
/>
